exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".search_form .items_list{height:calc(100vh - 135px);overflow-y:scroll}", "", {"version":3,"sources":["/Users/trungnq/Code/ksk/sns/public/pwa/src/components/search.vue"],"names":[],"mappings":"AACA,yBACE,2BAA4B,AAC5B,iBAAmB,CACpB","file":"search.vue","sourcesContent":["\n.search_form .items_list {\n  height: calc(100vh - 135px);\n  overflow-y: scroll;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3e9c4ec0","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/search.vue
// module id = 799
// module chunks = 0